export default function navigate(path: string, params: string)
{
	let l = window.location;
	var targetUrl = l.protocol + '//' + l.host + '/' + path + '#' + params;
	window.location.href = targetUrl;
}